import type { ReactNode } from "react";

type Tone = "info" | "warning";

const BG: Record<Tone, string> = {
  info: "var(--sk-action-soft)",
  warning: "var(--sk-warn-bg)",
};

export interface NoticeProps {
  tone?: Tone;
  /** Icône (lucide-react), décorative : le texte porte le sens. */
  icon?: ReactNode;
  /** « alert » pour une erreur à annoncer tout de suite, « status » sinon. */
  role?: "status" | "alert";
  children: ReactNode;
}

/** Message d'état sur une ligne ou deux : hors ligne, profil privé, code envoyé, erreur. */
export function Notice({ tone = "info", icon, role = "status", children }: NoticeProps) {
  return (
    <p
      role={role}
      style={{
        margin: 0,
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        background: BG[tone],
        color: tone === "warning" ? "var(--sk-warn-text)" : "var(--sk-title)",
        padding: "12px 14px",
        borderRadius: "var(--sk-radius-sm)",
        fontSize: 14,
        lineHeight: 1.4,
      }}
    >
      {icon && (
        <span aria-hidden style={{ flexShrink: 0, display: "flex", marginTop: 1 }}>
          {icon}
        </span>
      )}
      <span>{children}</span>
    </p>
  );
}
